// extracted by mini-css-extract-plugin
export default {"launchCalendarTab":"fa-z","nav":"ga-z","heading":"ha-z","active":"ia-z","mainCard":"ja-z"};